
export {} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$sticker.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$sticker.js';export default __x__;